import { createVuetify } from 'vuetify';
import 'vuetify/styles';
import * as hdColors from "@/theme/colors";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "hdTheme",
    themes: {
      hdTheme: {
        dark: false,
        colors: {
          white: "#ffffff",
          "on-white": hdColors.grey["400"],
          primary: hdColors.primary["500"],
          "on-primary": "#ffffff",
          accent: hdColors.primary["100"],
          "on-accent": hdColors.primary["500"],
          secondary: hdColors.blue["100"],
          "on-secondary": hdColors.blue["500"],
          undo: "#F5F5F5",
          "on-undo": hdColors.grey["700"],
          success: "#22c55e",
          "on-success": "#ffffff",
          error: "#e5414b",
          "on-error": "#ffffff",
          danger: "#e5414b",
          "on-danger": "#ffffff",
          warning: "#f8ab51",
          "on-warning": "#ffffff",
          information: "#8bd5ec",
          "on-information": "#ffffff",
        },
      },
    },
  },
});


export default vuetify;
